module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/store_images/5@2x_f51c67815fb0fb905c62a1b149e80dc8.png";